export default "__VITE_ASSET__DoKQ1Utm__"